'use strict';


define('forum/account/profile', [
    'forum/account/header',
    'bootbox',
    'api',
    'slugify'
], function (header, bootbox, api, slugify) {

    var Account = {};

    Account.init = function () {
	    header.init();

	    app.enterRoom('user/' + ajaxify.data.theirid);

	    processPage();

	    if (parseInt(ajaxify.data.emailChanged, 10) === 1) {
	        bootbox.alert('[[user:emailUpdate.change-instructions]]');
	    }

	    socket.removeListener('event:user_status_change', onUserStatusChange);
	    socket.on('event:user_status_change', onUserStatusChange);

	    $('#edit-username-submit').on('click', function updateUsername() {
	        var userData = {
			    uid: window.config.uid,
			    username: $('#edit-username-input').val()
	        };

	        if (!userData.username) {
			    app.alertError("username cnanot be empty!");
			    return;
	        }

	        api.put('/users/' + userData.uid, userData).then((response) => {

		        var {uid, username, userslug} = response;

		        if (userslug && parseInt(uid, 10) === parseInt(app.user.uid, 10)) {
		            $('[component="header/profilelink"]').attr('href', config.relative_path + '/user/' + userslug);
		            $('[component="header/profilelink/edit"]').attr('href', config.relative_path + '/user/' + userslug + '/edit');
		            $('[component="header/profilelink/settings"]').attr('href', config.relative_path + '/user/' + userslug + '/settings');
		            $('[component="header/username"]').text(username);
		            $('[component="header/usericon"]').css('background-color', response['icon:bgColor']).text(response['icon:text']);
		            $('[component="avatar/icon"]').css('background-color', response['icon:bgColor']).text(response['icon:text']);
		            $('#edit-userslug-input').val(username);
		            window.app.alertSuccess('[[user:profile_update_success]]');
		        }


	        }).catch(app.alertError);

	        return false;
	    });
    };

    function processPage() {
	    $('[component="posts"] [component="post/content"] img:not(.not-responsive), [component="aboutme"] img:not(.not-responsive)').addClass('img-responsive');
    }

    function onUserStatusChange(data) {
	    if (parseInt(ajaxify.data.theirid, 10) !== parseInt(data.uid, 10)) {
	        return;
	    }

	    app.updateUserStatus($('.account [data-uid="' + data.uid + '"] [component="user/status"]'), data.status);
    }

    return Account;
});
